import React from 'react';
import InputText from '../ReusableComponents/InputText';
import TextArea from '../ReusableComponents/TextArea';

const SpacePopup = ({ data }) => {
    if (!data) return null; 
  
    return (
      <div className="mx-auto md:w-[500px] w-full">
        <div className="relative w-full h-full max-w-xl md:h-auto">
          <div className="relative bg-white rounded-lg shadow">
            <div className="px-6 py-6 lg:px-8">
              <form className="space-y-6" action="#">
                <InputText
                  inputType="text"
                  title="Space"
                  name="space"
                  classStar="text-red-500"
                  content={data.Space}
                  disabled={true}
                  isRequired={true}
                />
  
                <TextArea
                  title="Description"
                  rows={7}
                  name="Description"
                  content={data.Description}
                  resize={false}
                  disabled={true}
                  // tabIndex="0"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  };

export default SpacePopup;